'use client';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { userState } from '@/slices/userSlice';
import { setCampaignUserInfo, popState, setCampaignSpinModal } from '@/slices/popSlice';
import campaignClient from '@/common/apiClient/campaignClient';

import CampaignTickets from './CampaignTickets'; // 持有抽獎券 中獎紀錄
import CampaignPrizes from './CampaignPrizes'; // 活動獎項
import CampaignTasks from './CampaignTasks'; // 活動任務區塊
import dayjs from 'dayjs';

const CampaignClientWrapper = ({ awards, tasks, spinSlug, drawTime, endTime }) => {
    const dispatch = useDispatch();
    const { user } = useSelector(userState);
    const { campaignUserInfo } = useSelector(popState); // 玩家資訊

    // 取得玩家活動資訊
    const getUserInfo = async () => {
        try {
            const result = await campaignClient.getCampaignUserInfo(spinSlug);
            // completedTaskIds: [] 已完成任務
            // drawLogs: [] 中獎紀錄
            // leftSpinTimes: 0 剩餘轉盤次數
            // spinAwards: [] 轉盤獎勵
            // tickets: 0 // 抽獎券數

            if (result) {
                dispatch(
                    setCampaignUserInfo({
                        ...result,
                        drawLogs: result?.drawLogs?.reverse() || [],
                        spinAwards: result?.spinAwards?.reverse() || [],
                        tickets: result?.tickets || 0,
                    })
                );

                // 取得每日開獎時間
                const [hour = 0, minute = 0] = drawTime?.split(':') || [];

                const realTime = dayjs(endTime)
                    .hour(hour)
                    .minute(minute)
                    .format('YYYY-MM-DD HH:mm');

                // 如果有剩餘次數、且活動還沒超過結束日期的抽獎時間 => 開啟輪盤
                if (result?.leftSpinTimes > 0 && dayjs().isBefore(realTime))
                    dispatch(setCampaignSpinModal(true));
            }
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        if (user?.uid) getUserInfo();
    }, [user?.uid]);

    return (
        <>
            {/* 持有抽獎券 中獎紀錄  */}
            <CampaignTickets user={user} ticketAmount={campaignUserInfo?.tickets} />

            {/* 活動獎項  */}
            <CampaignPrizes prizes={awards} />

            {/* 活動任務區塊 */}
            <CampaignTasks
                tasks={tasks}
                completedTaskIds={campaignUserInfo?.completedTaskIds}
                spinSlug={spinSlug}
                drawTime={drawTime}
            />
        </>
    );
};

export default CampaignClientWrapper;
